import { FC, useEffect, useMemo, useState } from "react";
import Button, { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { ReactComponent as TrashCan } from "images/TrashCan.svg";
import { deleteEmployee, editEmployeeRole } from "toolkit/steps/stepOne/stepOne.slice";
import InputTemp from "components-new/InputTemp";
import styles from "./AlreadyAdded.module.sass";
import { CommissionRole } from "toolkit/steps/stepOne/stepOne.types";
import { snackWrapper } from "helpers";
import {commissionsAPI} from "libs/apiClient/Commissions";

const AlreadyAdded: FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const { organizationId, commissionId } = useParams();
	const { alreadyAddedEmployees, roles } = useAppSelector((state) => state.stepOne);

	const [optionsRoles, setOptionsRoles] = useState<{ id: number; name: string }[]>([]);

	useEffect(() => {
		const flag = alreadyAddedEmployees.every((_) => {
			return _.commissionRoleId.name !== "Председатель";
		});
		if (!flag) {
			setOptionsRoles(roles.filter((_) => _.name !== "Председатель"));
		} else {
			setOptionsRoles(roles);
		}
	}, [alreadyAddedEmployees, roles]);

	const isDisabled = useMemo(() => {
		if (alreadyAddedEmployees.length && alreadyAddedEmployees.every((employee) => employee.commissionRoleId.id))
			return true;
	}, [alreadyAddedEmployees]);

	const formAnOrder = async () => {
		const body = alreadyAddedEmployees.map((employee) => {
			return {
				commissionId: 0,
				commissionRoleId: {
					id: employee.commissionRoleId.id,
					name: "",
				},
				employeeTableEmployee: {
					id: employee.employeeTableEmployee.id,
					firstName: "",
					lastName: "",
					middleName: "",
					position: "",
				},
				id: 0,
			};
		});

		try {
			let commission;
			if (commissionId) {
				commission = (await commissionsAPI.updateCreate(+commissionId!,body).then(({data})=>data));
			} else {
				commission = (await commissionsAPI.createCreate(+organizationId!,body).then(({data})=>data));
			}

			navigate(`/commission/${organizationId}/${commission?.listOfCommissionMembers[0].commissionId}`, {
				replace: true,
			});
			snackWrapper("success", "Приказ успешно сформирован");
		} catch (error) {
			snackWrapper("error", "Не удалось сформировать приказ");
		}
	};

	return (
		<div className={styles.alreadyAdded}>
			<div className={styles.title}>Уже добавили</div>
			<div className={styles.item}>
				<div data-comment-false={true} className={styles.list}>
					{alreadyAddedEmployees.map((employee) => (
						<div key={employee.id} className={styles.employee}>
							<div>
								<TrashCan
									className={styles.deleteIcon}
									onClick={() => dispatch(deleteEmployee(employee.employeeTableEmployee.id))}
								/>
								{employee.employeeTableEmployee.fullName}
								{/*{employee.employeeTableEmployee.lastName} {employee.employeeTableEmployee.firstName}{" "}*/}
								{/*{employee.employeeTableEmployee.middleName}*/}
							</div>
							<InputTemp
								className={styles.select}
								type="select"
								options={optionsRoles}
								value={employee?.commissionRoleId?.name ? employee.commissionRoleId.name : ""}
								onSelect={(role: CommissionRole) => {
									dispatch(editEmployeeRole({ employee, role }));
								}}
								placeholder="Неназначено"
								field={"name"}
							/>
						</div>
					))}
				</div>
				<div className={styles.buttons}>
					<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={() => navigate(-1)}>
						Отмена
					</Button>
					<Button onClick={formAnOrder} disabled={!isDisabled}>
						Сформировать приказ на создание комиссии
					</Button>
				</div>
			</div>
		</div>
	);
};

export default AlreadyAdded;
